import styled from 'styled-components'

export const Container = styled.div`
    padding: 30px;
    display: flex;
    /* background-color: #f8f9fa; */
    justify-content: space-between;
`